import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'catalog-list',
  templateUrl: './catalog-list.component.html',
  styleUrls: ['./catalog-list.component.scss']
})
export class CatalogListComponent implements OnInit {

  constructor(
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const queryParams = this._route.snapshot.queryParams;
    const networkId = queryParams.network;
    console.log("CATALOG LIST TAGGED BY NETWORK", networkId);
  }

}
